import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionOfficerSignature } from 'app/models/convention-officer-signature.model';
import { ConventionRegistration } from 'app/models/convention-registration.model';
import { DeleteConventionRegistrationHistory } from 'app/models/delete-convention-registration-history.model';
import { SignatureExtension } from 'app/models/extensions/signature-extension.model';

export class Signature extends SignatureExtension {
  imageString: string = null;
  signatureDBID: number = 0;
  digitalSignature: string;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  signatureName: string = null;
  conventionOfficerSignatures: ConventionOfficerSignature[] = [];
  conventionRegistrationSecondSignatures: ConventionRegistration[] = [];
  conventionRegistrationSignatures: ConventionRegistration[] = [];
  deleteConventionRegistrationHistories: DeleteConventionRegistrationHistory[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      imageString: new FormControl({ value: null, disabled: disableAll }),
      signatureDBID: new FormControl({ value: 0, disabled: disableAll }),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      signatureName: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(1024)]),
      digitalSignature: new FormControl({ value: null, disabled: disableAll }),
      conventionOfficerSignatures: new FormArray([]),
      conventionRegistrationSecondSignatures: new FormArray([]),
      conventionRegistrationSignatures: new FormArray([]),
      deleteConventionRegistrationHistories: new FormArray([])
    });


    return form;
  }
}
